import styled from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';

type InputProperties = {
  error?: boolean;
};

export const Input = styled.input<InputProperties>`
  display: block;
  width: 100%;
  background-color: ${palette('bgInput')};
  color: ${palette('colorInput')};
  border: 1px solid
    ${ifProp('error', palette('danger'), palette('borderInput'))};
  border-radius: ${theme('borderRadius.sm')};
  height: 38px;
  font-size: ${theme('fontSize.sm')};
  padding: 0 8px;
  outline: none;
  &::placeholder {
    color: ${palette('placeholderInputColor')};
    opacity: 1;
  }
  &:focus {
    box-shadow: 0 0 0 1px ${palette('primary')};
    border-color: ${ifProp(
      'error',
      palette('danger'),
      palette('borderInputFocus')
    )};
  }
  ${theme('components.TextField')}
`;
